export default "__VITE_ASSET__CCwF8t02__"